<template>
  <div>
    <ApplyDetail
      v-if="pageStatus === 'applyDetail'"
      :toDetailData="toDetailData"
      @changeToLeader="changeToLeader()"
    ></ApplyDetail>
    <ApplyLeader
      v-if="pageStatus === 'leader'"
      :toLedgerData="toLedgerData"
      @changeToDetail="changeToDetail"
    ></ApplyLeader>
  </div>
</template>
<script>
import ApplyDetail from "./applyDetail/ApplyDetail";
import ApplyLeader from "./applyLeader/ApplyLeader";
export default {
  name: "BidApply",
  components: {
    ApplyDetail,
    ApplyLeader,
  },
  data() {
    return {
      pageStatus: "leader",
      toDetailData: {},
      toLedgerData: {
        page: 1,
        pageSize: 10,
        queryProjectStatus: undefined,
        queryProjectName: undefined,
      },
    };
  },
  methods: {
    changeToLeader() {
      this.pageStatus = "leader";
    },
    changeToDetail(val) {
      this.toLedgerData.page = val.page;
      this.toLedgerData.pageSize = val.pageSize;
      this.toLedgerData.queryProjectStatus = val.queryProjectStatus;
      this.toLedgerData.queryProjectName = val.queryProjectName;
      this.toDetailData = {
        webId: val.webId,
        projectStatus: val.projectStatus,
        isEditable: val.isEditable,
        selectHouseList: val.selectHouseList,
      };
      this.pageStatus = "applyDetail";
    },
  },
};
</script>

<style>
</style>